// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */
import { universalTypeFilterId } from '../../../../common/constants/filters';

import { filter as archivedFilter } from './archived';
import { filter as archivedAndPendingComponentsFilter } from './archived-and-pending-components';
import { filter as assetsSchemaFilter } from './assets-schema';
import { filter as assetsTypeFilter } from './assets-type';
import { filter as assigneeFilter } from './assignee';
import { filter as commentedByMeFilter } from './commentedByMe';
import { filter as contentFilter } from './content';
import { filter as contributorFilter } from './contributor';
import { filter as createdByFilter } from './created-by';
import { filter as focusAreaTypeFilter } from './focus-area-type';
import { filter as focusAreaUnderFilter } from './focus-area-under';
import { filter as labelFilter } from './label';
import { filter as lastUpdatedFilter } from './last-updated';
import { filter as lastUpdatedByFilter } from './last-updated-by';
import { filter as ownerFilter } from './owner';
import { filter as pageStatusFilter } from './page-status';
import { filter as positionEmploymentTypeFilter } from './position-employment-type';
import { filter as positionFocusAreaFilter } from './position-focus-area';
import { filter as positionJobFamilyFilter } from './position-job-family';
import { filter as positionStatusFilter } from './position-status';
import { filter as positionTeamFilter } from './position-team';
import { filter as projectFilter } from './project';
import { filter as reporterFilter } from './reporter';
import { filter as spaceFilter } from './space';
import { filter as statusFilter } from './status';
import { filter as titleMatchFilter } from './title-match-only';
import { filter as universalTypeFilter } from './universal-type';
import { filter as verifiedFilter } from './verified';
import { filter as watchedFilter } from './watched';

export const allFilters: Readonly<{
    lastUpdated: Readonly<{
        id: "lastUpdated";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"lastUpdated">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"lastUpdated">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    contributor: Readonly<{
        id: "contributor";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"contributor">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"contributor">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    space: Readonly<{
        id: "space";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"space">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"space">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    watchedByMe: Readonly<{
        id: "watchedByMe";
        type: "boolean";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/boolean-filter/types").BooleanFilterMonad<"watchedByMe">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/boolean-filter/types").BooleanFilterMonad<"watchedByMe">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    verified: Readonly<{
        id: "verified";
        type: "boolean";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/boolean-filter/types").BooleanFilterMonad<"verified">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/boolean-filter/types").BooleanFilterMonad<"verified">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    assignee: Readonly<{
        id: "assignee";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"assignee">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"assignee">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    reporter: Readonly<{
        id: "reporter";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"reporter">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"reporter">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    commentedByMe: Readonly<{
        id: "commentedByMe";
        type: "boolean";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/boolean-filter/types").BooleanFilterMonad<"commentedByMe">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/boolean-filter/types").BooleanFilterMonad<"commentedByMe">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    project: Readonly<{
        id: "project";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"project">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"project">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    universalTypeFilter: Readonly<{
        id: "universalTypeFilter";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"universalTypeFilter">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"universalTypeFilter">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    content: Readonly<{
        id: "content";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"content">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"content">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    onlyTitleMatch: Readonly<{
        id: "onlyTitleMatch";
        type: "boolean";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/boolean-filter/types").BooleanFilterMonad<"onlyTitleMatch">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/boolean-filter/types").BooleanFilterMonad<"onlyTitleMatch">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    owner: Readonly<{
        id: "owner";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"owner">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"owner">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    createdBy: Readonly<{
        id: "createdBy";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"createdBy">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"createdBy">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    label: Readonly<{
        id: "label";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"label">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"label">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    focusAreaType: Readonly<{
        id: "focusAreaType";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"focusAreaType">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"focusAreaType">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    focusAreaUnder: Readonly<{
        id: "focusAreaUnder";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"focusAreaUnder">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"focusAreaUnder">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    pageStatus: Readonly<{
        id: "pageStatus";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"pageStatus">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"pageStatus">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    archived: Readonly<{
        id: "archived";
        type: "boolean";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/boolean-filter/types").BooleanFilterMonad<"archived">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/boolean-filter/types").BooleanFilterMonad<"archived">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    lastUpdatedBy: Readonly<{
        id: "lastUpdatedBy";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"lastUpdatedBy">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"lastUpdatedBy">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    statusFilter: Readonly<{
        id: "statusFilter";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"statusFilter">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"statusFilter">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    compassArchived: Readonly<{
        id: "compassArchived";
        type: "boolean";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/boolean-filter/types").BooleanFilterMonad<"compassArchived">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/boolean-filter/types").BooleanFilterMonad<"compassArchived">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    assetsSchema: Readonly<{
        id: "assetsSchema";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"assetsSchema">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"assetsSchema">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    assetsType: Readonly<{
        id: "assetsType";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"assetsType">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"assetsType">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    positionStatus: Readonly<{
        id: "positionStatus";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"positionStatus">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"positionStatus">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    positionEmploymentType: Readonly<{
        id: "positionEmploymentType";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"positionEmploymentType">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"positionEmploymentType">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    positionJobFamily: Readonly<{
        id: "positionJobFamily";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"positionJobFamily">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"positionJobFamily">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    positionTeam: Readonly<{
        id: "positionTeam";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"positionTeam">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"positionTeam">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
    positionFocusArea: Readonly<{
        id: "positionFocusArea";
        type: "single-select" | "multi-select";
        queryParams: {
            key: string;
        };
        products: import("../../../..").ProductKeys[];
        universal: boolean;
        customValueFields?: string[];
        withState: (state: unknown, config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"positionFocusArea">;
        getInitialState: (config: import("../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"positionFocusArea">;
        isCompatible: (filterId?: string) => boolean;
        isSupportCustomValue: boolean;
        isSuggestedFilter?: (primaryProduct?: string) => boolean;
    }>;
}> = Object.freeze({
	[lastUpdatedFilter.id]: lastUpdatedFilter,
	[contributorFilter.id]: contributorFilter,
	[spaceFilter.id]: spaceFilter,
	[watchedFilter.id]: watchedFilter,
	[verifiedFilter.id]: verifiedFilter,
	[assigneeFilter.id]: assigneeFilter,
	[reporterFilter.id]: reporterFilter,
	[commentedByMeFilter.id]: commentedByMeFilter,
	[projectFilter.id]: projectFilter,
	[universalTypeFilterId]: universalTypeFilter,
	[contentFilter.id]: contentFilter,
	[titleMatchFilter.id]: titleMatchFilter,
	[ownerFilter.id]: ownerFilter,
	[createdByFilter.id]: createdByFilter,
	[labelFilter.id]: labelFilter,
	[focusAreaTypeFilter.id]: focusAreaTypeFilter,
	[focusAreaUnderFilter.id]: focusAreaUnderFilter,
	[pageStatusFilter.id]: pageStatusFilter,
	[archivedFilter.id]: archivedFilter,
	[lastUpdatedByFilter.id]: lastUpdatedByFilter,
	[statusFilter.id]: statusFilter,
	[archivedAndPendingComponentsFilter.id]: archivedAndPendingComponentsFilter,
	[assetsSchemaFilter.id]: assetsSchemaFilter,
	[assetsTypeFilter.id]: assetsTypeFilter,
	[positionStatusFilter.id]: positionStatusFilter,
	[positionEmploymentTypeFilter.id]: positionEmploymentTypeFilter,
	[positionJobFamilyFilter.id]: positionJobFamilyFilter,
	[positionTeamFilter.id]: positionTeamFilter,
	[positionFocusAreaFilter.id]: positionFocusAreaFilter,
});

export {
	archivedFilter,
	archivedAndPendingComponentsFilter,
	assigneeFilter,
	reporterFilter,
	commentedByMeFilter,
	createdByFilter,
	contentFilter,
	contributorFilter,
	lastUpdatedFilter,
	lastUpdatedByFilter,
	pageStatusFilter,
	projectFilter,
	spaceFilter,
	watchedFilter,
	verifiedFilter,
	titleMatchFilter,
	universalTypeFilter,
	ownerFilter,
	labelFilter,
	focusAreaTypeFilter,
	focusAreaUnderFilter,
	statusFilter,
	assetsSchemaFilter,
	assetsTypeFilter,
	positionStatusFilter,
	positionEmploymentTypeFilter,
	positionJobFamilyFilter,
	positionTeamFilter,
	positionFocusAreaFilter,
};
